import { ChangeEvent, useContext, useEffect, useState } from "react";
import "./Forgotpassword.scss";
import { Form, Button } from "react-bootstrap";
import { BankUserContext } from "../../bankUserContext";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import eyeIcon from "../../images/eyeIcon.svg";
import logoFooter from "../../images/logoFooter.svg";
import { APP_Config } from "../../utils/AppConfig";
import { AxiosResponse } from "axios";
import Service from "../../services";
import FinSpinner from "../../commonfields/FinSpinner";
import Logo from "../../images/NoLogo.svg";
import { catchError } from "../../utils/Utils";
import { Helmet } from "react-helmet";

interface ColorProps {
  name: string;
  color: string;
  group: string;
}
interface Menu {
  prospecting: string;
  relationship: string;
  caseTracker: string;
  messageCenter: string;
  applications: string,
  opportunities: string,
  underwriting: string,
  trackers: string;
  settings: string,
  tabName: string
}
const ResetPassword = (props: any) => {
  const service = new Service();
  const { organizationId } = props
  const params = useParams();
  const [passwordError, setpasswordError] = useState<string | null>(null);
  const [uppercasecolour, setuppercasecolour] = useState<string | null>(null);
  const [numbercolour, setnumbercolour] = useState<string | null>(null);
  const [symbolcolour, setsymbolcolour] = useState<string | null>(null);
  const [min8charcolour, setmin8charcolour] = useState<string | null>(null);
  const [password, setpassword] = useState<string | null>(null);
  const [cnfpassword, setCnfpassword] = useState<string | null>(null);
  const [cnfpasswordError, setcnfpasswordError] = useState<string | null>(null);
  const [createAccountdisable, setcreateAccountdisable] =
    useState<boolean>(true);
  const [loginSuccess, setloginSuccess] = useState<boolean>(false);
  const [loader, setLoader] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [redirectType, setRedirectType] = useState<boolean>();
  const [theme, setTheme] = useState("default");
  const [logosList, setLogosList] = useState<any[]>([]);
  const [dynamicFavIcon, setDynamicFavIcon] = useState();
  const [colorsArray, setColorsArray] = useState<ColorProps[]>([]);
  const [menuItems, setMenuItemsArray] = useState<Menu>({ prospecting: "", relationship: "", caseTracker: "", messageCenter: "", applications: "", opportunities: "", underwriting: "", trackers: "", settings: "", tabName: "" });
  const navigate = useNavigate();
  const [expiredinvitationId, setExpiredInvitationId] = useState<string>("");

  const getIsoNameByUrl = () => {
    // customerService
    //   .getIsoNameByUrl()
    //   .then((res) => {
    //     const profile = res?.data?.iso;
    //     if (profile) {
    //       profile &&
    //         document.body.classList.add(
    //           `theme-${profile?.toLocaleLowerCase()}`
    //         );
    //       ChangePageTitle(profile);
    //     } else document.body.classList.add("theme-default");
    //     setTheme(profile);
    //   })
    //   .catch((err) => {
    //     catchError(err, true);
    //     document.body.classList.add("theme-default");
    //   });
  };

  useEffect(() => {
    getLogoList(organizationId);
    getColorsList(organizationId);
    resetPasswordLinkStatus();
    document.body.classList.add("forgotBG");
    getIsoNameByUrl();
    return () => {
      document.body.classList.remove("forgotBG");
    };
  }, []);

  const resetPasswordLinkStatus = () => {
    const invitationId = params?.id;
    service.resetPasswordLinkStatus(invitationId).then((res: any) => {
      setExpiredInvitationId(res.data)
    })
  }



  // #3d3d3d
  const getLogoList = (orgId: string) => {
    service.getOrgLogos(orgId)
      .then((res: any) => {
        setLogosList(res.data);
        setDynamicFavIcon(res.data.find((item: any) => item.iconkey === "favIcon").logopath)
        if (res.data.length > 0) {
          // console.log(JSON.parse(res.data[0].logo_path).filePath);
        }
      })
      .catch((err) => {
        catchError(err, false);
      });
  }
  const getColorsList = (orgId: any) => {
    service
      .getBrandColors(orgId)
      .then((res: any) => {
        setColorsArray(JSON.parse(res?.data[0]?.template_style) || []);
        setMenuItemsArray(JSON.parse(res?.data[0]?.menu_item_data) || []);
      })
      .catch((err) => {
        catchError(err, false);
      });
  };
  const setCssVariable = (variableName: string, color: string) => {
    document.documentElement.style.setProperty(variableName, color);
  };
  function hexToRgb(hexColor: string): string {
    // remove the # tag
    const hex = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;
    const red = parseInt(hex.substring(0, 2), 16);
    const green = parseInt(hex.substring(2, 4), 16);
    const blue = parseInt(hex.substring(4, 6), 16);
    return `${red}, ${green}, ${blue}`;
  }
  const setColorAndCssVariable = (
    colorName: string,
    defaultColor: string,
    colorsArray: ColorProps[]
  ) => {
    const colorData = colorsArray.find((color) => color.name === colorName);
    const color = colorData?.color || defaultColor;

    // Set the CSS variable
    document.documentElement.style.setProperty(
      `--${colorName}`,
      hexToRgb(color)
    );

    return color;
  };
  const loginSecondaryBackgroundColor = setColorAndCssVariable(
    "loginSecondaryBackgroundColor",
    "#3d3d3d",
    colorsArray
  );
  const loginPrimaryBackgroundColor = setColorAndCssVariable(
    "loginPrimaryBackgroundColor",
    "#252525",
    colorsArray
  );
  useEffect(() => {
    // Set the CSS variables using the previously set colors
    setCssVariable(
      "--loginPrimaryBackgroundColor",
      hexToRgb(loginPrimaryBackgroundColor)
    );
    setCssVariable(
      "--loginSecondaryBackgroundColor",
      hexToRgb(loginSecondaryBackgroundColor)
    );
  }, [colorsArray]);

  const bankUserContext = useContext(BankUserContext);
  if (bankUserContext.bankuserDetails !== null) {
    navigate("/landing");
  }
  const handleshowhideNewpassword = () => {
    setShowNewPassword(!showNewPassword);
  };
  const handleshowhideConfirmNewpassword = () => {
    setShowConfirmNewPassword(!showConfirmNewPassword);
  };
  const validations = () => {
    if (
      password &&
      cnfpassword &&
      uppercasecolour &&
      numbercolour &&
      symbolcolour &&
      min8charcolour &&
      cnfpasswordError === null
    ) {
      return false;
    } else {
      return true;
    }
  };
  const passworduppercaseRegex = new RegExp("^(?=.*[A-Z])");
  const passwordnumberRegex = new RegExp("^(?=.*[0-9])");
  const passwordsymbolRegex = new RegExp(
    /^(?=.*[!@#$%^&*()\-_=+{}[\]|\\;:'"<>,./?~`])[\S]+$/
  );
  const passwordsymbolRegexSpace = new RegExp(/\s/);
  const passwordmin8charRegex = new RegExp("^(?=.{8,})");
  const createAccount = (e: any) => {
    setLoader(true);
    e.preventDefault();
    const invitationId = params?.id;
    if (
      uppercasecolour != null &&
      numbercolour != null &&
      symbolcolour != null &&
      min8charcolour != null &&
      cnfpasswordError === null
    ) {
      const userData = {
        screen: "LoginPage",
        sections: "ResetPassword",
        newPassword: password,
        conformNewPassword: cnfpassword,
        invitationId: invitationId,
        isJsonReturnObject: false,
      };
      service
        .resetPassword(userData)
        .then((response: AxiosResponse) => {
          if (response.status === 200) {
            setLoader(false);
            setloginSuccess(true);
            setRedirectType(response.data[0]?.isclient);
          } else {
            setLoader(false);
            // toast.error(
            //   <>
            //     <div className="fileErrorMessage">Something went wrong..</div>
            //   </>
            // );
          }
        })
        .catch((error: any) => {
          if (error.response.data) {
            setLoader(false);
            toast.error(error.response.data.errorMessage);
          }
        });
    }
  };

  const onChangeField = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
    fieldName: string
  ) => {
    if (fieldName === "password") {
      if (e.target.value === "") {
        setpasswordError("*Required");
        setuppercasecolour(null);
        setnumbercolour(null);
        setsymbolcolour(null);
        setmin8charcolour(null);
        setpassword(e.target.value);
      } else if (e.target.value) {
        passworduppercaseRegex.test(e.target.value)
          ? setuppercasecolour("green")
          : setuppercasecolour(null);
        passworduppercaseRegex.test(e.target.value)
          ? setuppercasecolour("green")
          : setcreateAccountdisable(true);
        passwordnumberRegex.test(e.target.value)
          ? setnumbercolour("green")
          : setnumbercolour(null);
        passwordnumberRegex.test(e.target.value)
          ? setnumbercolour("green")
          : setcreateAccountdisable(true);
        if (
          passwordsymbolRegex.test(e.target.value) ||
          passwordsymbolRegexSpace.test(e.target.value)
        ) {
          setsymbolcolour("green");
        } else {
          setsymbolcolour(null);
          setcreateAccountdisable(true);
        }
        passwordmin8charRegex.test(e.target.value)
          ? setmin8charcolour("green")
          : setmin8charcolour(null);
        passwordmin8charRegex.test(e.target.value)
          ? setmin8charcolour("green")
          : setcreateAccountdisable(true);
        setpasswordError(null);
        setpassword(e.target.value);
      } else {
        setpasswordError(null);
        setpassword(e.target.value);
      }
      if (cnfpassword && e.target.value !== cnfpassword) {
        setcnfpasswordError("Passwords don't match");
        setcreateAccountdisable(true);
      } else {
        setcnfpasswordError(null);
        setcreateAccountdisable(false);
      }
    } else if (fieldName === "cnfpassword") {
      if (e.target.value === "") {
        setCnfpassword(e.target.value);
        setcnfpasswordError("*Required");
      } else if (e.target.value !== password) {
        setCnfpassword(e.target.value);
        setcnfpasswordError("Passwords don't match");
      } else {
        setcnfpasswordError(null);
        setCnfpassword(e.target.value);
        if (
          password &&
          uppercasecolour &&
          numbercolour &&
          symbolcolour &&
          min8charcolour &&
          cnfpasswordError === null
        ) {
          setcreateAccountdisable(false);
        }
      }
    }
  };
  const loginbtn = () => {
    const type = redirectType
      ? APP_Config().REACT_APP_CLIENT_PORTAL_ID
      : APP_Config().REACT_APP_CLIENT_ID;
    return (window.location.href = `${APP_Config().REACT_APP_BASE_URL
      }authorization/authorize?clientId=${type}`);
  };

  return (
    <><Helmet>
      <meta charSet="utf-8" />
      <title>{menuItems?.tabName ? menuItems?.tabName : "nFiniti.AI Portal"}</title>
      <link rel="icon" href={dynamicFavIcon} />
    </Helmet>
      <div className="vHeight">
        {loginSuccess ? (
          <div className="container-fluid userResetScreens">
            <div className="flex-1">
              <img
                className="mainLogo"
                src={
                  logosList?.find((item: any) => item.iconkey === "headerIcon")?.logopath || Logo
                }
                alt="logo"
              />
            </div>
            <div className="form-signinPasswordSucces">
              <div className="smallLogo"></div>
              <h2 className="form-signin-heading">Reset Password</h2>
              <h6 className="successHeading1">
                Your password has been successfully reset
              </h6>
              <div>
                <div>
                  <Button className="btnBacktoSignIn" onClick={() => loginbtn()}>
                    Go to Sign In
                  </Button>
                </div>
              </div>
            </div>
            <p className="d-flex footerLogo">
              {logosList?.find((item: any) => item.iconkey === "poweredBy")?.logoname}
              <img src={logoFooter} alt="footerLogo" />
            </p>
          </div>
        ) : (
          <div className="container-fluid userResetScreens">
            <div className="flex-1">
              <img
                className="mainLogo"
                src={
                  logosList?.find((item: any) => item.iconkey === "headerIcon")
                    ?.logopath || Logo
                }
                alt="logo"
              />
            </div>
            <div className="form-signinresetPassword">
              <div className="smallLogo">
                <img
                  //className="mainLogo"
                  src={
                    logosList?.find((item: any) => item.iconkey === "loginIcon")
                      ?.logopath || Logo
                  }
                  alt="logo"
                />
              </div>
              {!expiredinvitationId ?
                <>
                  <h2 className="form-signin-heading">Reset Password</h2>
                  <div className="heading-reset">
                    In order to protect your account, your password must contain at
                    least:{" "}
                  </div>
                  <ul className="passHint2 mb-3">
                    <li className={uppercasecolour !== null ? "green" : ""}>
                      One uppercase
                    </li>
                    <li className={numbercolour ? "green" : ""}>One number</li>
                    <li className={symbolcolour ? "green" : ""}>One symbol</li>{" "}
                    <li className={min8charcolour ? "green" : ""}>8 characters</li>
                  </ul>
                  <Form className="resetPassword">
                    <Form.Group controlId="formBasicEmail">
                      <Form.Label>New Password</Form.Label>
                      <Form.Control
                        className="changePassword2"
                        type={showNewPassword ? "text" : "password"}
                        placeholder=""
                        onChange={(e: any) => onChangeField(e, "password")}
                      />
                      <img
                        src={eyeIcon}
                        alt="eyeIcon"
                        onClick={handleshowhideNewpassword}
                        className="eyeIcon"
                      />
                      <span className="errorMsg">{passwordError}</span>
                    </Form.Group>
                    <Form.Group controlId="formBasicEmail">
                      <Form.Label>Confirm New Password</Form.Label>
                      <Form.Control
                        className="changePassword2"
                        type={showConfirmNewPassword ? "text" : "password"}
                        placeholder=""
                        onChange={(e: any) => onChangeField(e, "cnfpassword")}
                      />
                      <img
                        src={eyeIcon}
                        alt="eyeIcon"
                        onClick={handleshowhideConfirmNewpassword}
                        className="eyeIcon"
                      />
                      <span className="errorMsg">{cnfpasswordError}</span>
                    </Form.Group>
                    <div className="btnWrapper2">
                      <Button
                        type="submit"
                        className="btn-white btn-submit"
                        disabled={
                          validations()
                          // true
                        }
                        onClick={createAccount}
                      >
                        Reset password
                      </Button>
                    </div>
                  </Form>
                </>
                : <>
                  <div className="expiredDiv">
                    <h2 className="expiredText">Reset Password Link Has Expired</h2>
                  </div>
                </>}
            </div>
            <p className="d-flex footerLogo">
              {logosList?.find((item: any) => item.iconkey === "poweredBy")?.logoname}
              <img src={logoFooter} alt="footerLogo" />
            </p>
          </div>
        )}

        {loader ? <FinSpinner /> : null}
      </div>
    </>
  );
};

export default ResetPassword;
